import { ComponentProps, forwardRef } from "react";

import cn from "@/helpers/classNames";

import GoogleIcon from "./google.svg?react";

const GOOGLE_OAUTH_INTEGRATION_IDS = new Set(["gmail"]);

export function usesGoogleSignIn(integrationId: string) {
  return (
    integrationId.startsWith("google-") ||
    GOOGLE_OAUTH_INTEGRATION_IDS.has(integrationId)
  );
}

// Colours, spacing, font and logo size are fixed by https://developers.google.com/identity/branding-guidelines
export const GoogleSignInButton = forwardRef<
  HTMLButtonElement,
  Omit<ComponentProps<"button">, "children"> & {
    isDisabled?: boolean;
    isLoading?: boolean;
  }
>(({ isDisabled, isLoading, className, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      {...props}
      disabled={Boolean(isDisabled || isLoading || props.disabled)}
      aria-busy={isLoading || undefined}
      className={cn(
        "inline-flex h-10 shrink-0 items-center gap-2.5 rounded-sm border pr-3 pl-3",
        "text-sm leading-5 font-medium whitespace-nowrap",
        "border-[#747775] bg-white text-[#1F1F1F] hover:bg-[#EDEDED]",
        "dark:border-[#8E918F] dark:bg-[#131314] dark:text-[#E3E3E3] dark:hover:bg-[#242425]",
        "focus:ring-2 focus:ring-offset-2 focus:outline-hidden dark:ring-offset-gray-900",
        "disabled:pointer-events-none disabled:opacity-[0.38]",
        className,
      )}
    >
      <GoogleIcon className="size-5 shrink-0" aria-hidden />
      <span>Sign in with Google</span>
    </button>
  );
});
